<template>
  <div class="shop-detail">
    <div class="header">
      <TopBar :title="$t('exchangePage.xiangqing')" />
    </div>
    <div class="body">
      <div class="card">
        <div class="left">
          <van-image
            width="1.8rem"
            height="1.8rem"
            :src="detail.thumbImageUrl"
          />
        </div>
        <div class="right">
          <div class="name">{{ detail.name }}</div>
          <div class="money">
            <van-icon name="points" /> {{ detail.displayPoints }}
          </div>
          <div class="count">
            <span> {{ $t("gdh") }} {{ detail.convertTimes }} </span>
            <span style="margin-left: 0.4rem">
              {{ $t("sy") }} {{ detail.stock }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="desc-text">
      <div>{{ $t("exchangePage.tips1") }}</div>
      <div>{{ $t("exchangePage.tips2") }}</div>
    </div>
    <div class="exchange-btn">
      <van-button round type="info" @click="toExchange">{{
        $t("exchangePage.btn")
      }}</van-button>
    </div>

    <van-dialog
      class="exchange-dialog"
      v-model="showDialog"
      :title="$t('exchangePage.tip')"
      show-cancel-button
      @confirm="confirm"
      :cancel-button-text="$t('exchangePage.cancel')"
      :confirm-button-text="$t('exchangePage.confirm')"
    >
      <div>{{ $t("exchangePage.dialog1") }}</div>
      <div>
        {{ $t("exchangePage.dialog2") }} {{ $store.state.loginInfo.paypal }}
      </div>
      <div>
        {{ $t("exchangePage.dialog3") }} {{ $store.state.userInfo.name }}
      </div>
    </van-dialog>

    <van-dialog
      class="add-info"
      :confirm-button-text="$t('exchangePage.update')"
      v-model="showUpdateDialog"
      :title="$t('exchangePage.tip')"
      show-cancel-button
      @confirm="confirmUpdate"
    >
      <div>{{ $t("exchangePage.noInfo") }}</div>
      <div>{{ $t("exchangePage.pleaseUpdate") }}</div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import axios from "axios";
import { GiftsDetail, handleOrder, accountsAlipay } from "@/api/api.js";
import { Notify } from "vant";
import TopBar from "@/common/top-bar/index.vue";
import { mapState } from "vuex";
export default {
  name: "ShopDetail",
  components: {
    TopBar,
  },
  data() {
    return {
      showDialog: false,
      showUpdateDialog: false,
      hasInfo: true,
      id: 0,
      detail: {},
    };
  },
  computed: {
    ...mapState(["loginInfo"]),
  },
  watch: {
    id(val) {
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    toExchange() {
      if (this.$store.state.loginInfo.paypal === "") {
        this.showUpdateDialog = true;
      } else {
        //更新兑换信息
        if (!this.loginInfo.paypalConfirmed) {
          this.$dialog
            .confirm({
              title: this.$t("tip"),
              message: this.$t("improveExchangeInformation"),
              cancelButtonText: this.$t("exchangePage.cancel"),
              confirmButtonText: this.$t("exchangePage.update"),
              confirmButtonColor: "#FBC260",
            })
            .then(() => {
              this.$router.push({ name: "UpdateInfo" });
            })
            .catch(() => {});
        } else {
          this.showDialog = true;
        }
      }
    },
    confirm() {
      this.handle();
    },
    confirmUpdate() {
      this.showUpdateDialog = false;
      this.$router.push("/updateInfo");
    },
    getList() {
      const params = {
        id: this.$route.query.id,
      };
      GiftsDetail(params).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        } else {
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
    // 立即兑换
    handle() {
      const params = {
        giftId: this.$route.query.id,
      };
      handleOrder(params).then((res) => {
        if (res.code === 200) {
          Toast({
            className: "noticeWidth",
            message: res.data.memo,
            forbidClick: true,
          });
          this.getList();
        } else {
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    if (JSON.stringify(this.$store.state.loginInfo) === "{}") {
      this.$store.dispatch("getAccountInfo");
    }
  },
  activated() {},
};
</script>

<style lang="stylus" scoped>
/deep/.shop-detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f3f3f3;

  .body {
    display: flex;
    justify-content: center;
    margin-top: 0.2rem;

    .card {
      border-radius: 0.2rem;
      width: 90%;
      height: 2.2rem;
      background: #ffffff;
      display: flex;
      align-items: center;
      font-weight: bold;

      .left {
        margin-left: 0.2rem;
      }

      .right {
        margin: 0px 0.2rem;

        .money {
          color: #F67E3D;
          margin-top: 0.3rem;
          margin-bottom: 0.3rem;
        }

        .count {
          color: #8E8D8D;
        }
      }
    }
  }

  .desc-text {
    color: #C75353;
    padding-right: 20px;
    margin-left: 0.4rem;
    margin-top: 0.4rem;
    line-height: 0.375rem;

    div:nth-child(2) {
      margin-top: 0.3rem;
    }
  }

  .exchange-btn {
    margin-top: 1.5rem;
    text-align: center;

    button {
      width: 80%;
      background: #0056b5;
      border: #0056b5;
      font-size: 0.3rem;
      font-weight: 500;
    }
  }

  .exchange-dialog.van-dialog {
    width: 80%;

    .van-dialog__content {
      color: #9F9C9C;
      font-weight: bold;
      padding: 0.3rem;

      div:nth-child(2) {
        margin: 0.2rem 0;
      }
    }

    .van-dialog__footer {
      .van-dialog__cancel {
        background: #97C1E2;
        color: #ffffff;
      }

      .van-dialog__confirm {
        background: #97C1E2;
        color: #FBC260;
      }

      .van-dialog__confirm:hover {
        background: #5376C2;
        color: #FFFFFF;
      }
    }
  }

  .add-info.van-dialog {
    .van-dialog__content {
      color: #9F9C9C;
      font-weight: bold;
      padding: 0.3rem;
      text-align: center;

      div:nth-child(2) {
        margin: 0.2rem 0;
      }
    }

    .van-dialog__footer {
      .van-dialog__cancel {
        background: #97C1E2;
        color: #ffffff;
      }

      .van-dialog__confirm {
        background: #97C1E2;
        color: #FBC260;
      }

      .van-dialog__confirm:hover {
        background: #5376C2;
        color: #FFFFFF;
      }
    }
  }
}
</style>
<style lang="stylus">
/deep/.shop-detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f3f3f3;

  .body {
    display: flex;
    justify-content: center;
    margin-top: 0.2rem;

    .card {
      border-radius: 0.2rem;
      width: 90%;
      height: 2.2rem;
      background: #ffffff;
      display: flex;
      align-items: center;
      font-weight: bold;

      .left {
        margin-left: 0.2rem;
      }

      .right {
        margin: 0px 0.2rem;

        .money {
          color: #F67E3D;
          margin-top: 0.3rem;
          margin-bottom: 0.3rem;
        }

        .count {
          color: #8E8D8D;
        }
      }
    }
  }

  .desc-text {
    color: #C75353;
    padding-right: 20px;
    margin-left: 0.4rem;
    margin-top: 0.4rem;
    line-height: 0.375rem;

    div:nth-child(2) {
      margin-top: 0.3rem;
    }
  }

  .exchange-btn {
    margin-top: 1.5rem;
    text-align: center;

    button {
      width: 80%;
      background: #FBC260;
      border: #FBC260;
    }
  }

  .exchange-dialog.van-dialog {
    width: 80%;

    .van-dialog__content {
      color: #9F9C9C;
      font-weight: bold;
      padding: 0.3rem;

      div:nth-child(2) {
        margin: 0.2rem 0;
      }
    }

    .van-dialog__footer {
      .van-dialog__cancel {
        background: #97C1E2;
        color: #ffffff;
      }

      .van-dialog__confirm {
        background: #97C1E2;
        color: #FBC260;
      }

      .van-dialog__confirm:hover {
        background: #5376C2;
        color: #FFFFFF;
      }
    }
  }

  .add-info.van-dialog {
    .van-dialog__content {
      color: #9F9C9C;
      font-weight: bold;
      padding: 0.3rem;
      text-align: center;

      div:nth-child(2) {
        margin: 0.2rem 0;
      }
    }

    .van-dialog__footer {
      .van-dialog__cancel {
        background: #97C1E2;
        color: #ffffff;
      }

      .van-dialog__confirm {
        background: #97C1E2;
        color: #FBC260;
      }

      .van-dialog__confirm:hover {
        background: #5376C2;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shopDetail/ShopDetail.vue